// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AlojamientoRouteImport } from './routes/alojamiento'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CasaRuralCercaMadridRouteImport } from './routes/casa-rural-cerca-madrid'
import { Route as CasaRuralConChimeneaRouteImport } from './routes/casa-rural-con-chimenea'
import { Route as CasaRuralEscapadaRomanticaRouteImport } from './routes/casa-rural-escapada-romantica'
import { Route as CasaRuralGuadalajaraRouteImport } from './routes/casa-rural-guadalajara'
import { Route as CasaRuralGuadalajaraGruposRouteImport } from './routes/casa-rural-guadalajara-grupos'
import { Route as CasaRuralHayedoTejeraNegraRouteImport } from './routes/casa-rural-hayedo-tejera-negra'
import { Route as CasaRuralPueblosNegrosRouteImport } from './routes/casa-rural-pueblos-negros'
import { Route as CasaRuralSierraNorteGuadalajaraRouteImport } from './routes/casa-rural-sierra-norte-guadalajara'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as DorsalesRouteImport } from './routes/dorsales'
import { Route as EntornoRouteImport } from './routes/entorno'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FinanciacionRouteImport } from './routes/financiacion'
import { Route as GaleriaRouteImport } from './routes/galeria'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as ReservaRouteImport } from './routes/reserva'
import { Route as SanSilvestreSierraNorteRouteImport } from './routes/san-silvestre-sierra-norte'
import { Route as TarifasRouteImport } from './routes/tarifas'
import { Route as AuthenticatedGestionRouteImport } from './routes/_authenticated/gestion'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CheckinTokenRouteImport } from './routes/checkin.$token'
import { Route as GestionEscanearRouteImport } from './routes/gestion_.escanear'
import { Route as GestionValidarRouteImport } from './routes/gestion_.validar'
import { Route as LegalAvisoLegalRouteImport } from './routes/legal.aviso-legal'
import { Route as LegalCondicionesRouteImport } from './routes/legal.condiciones'
import { Route as LegalCookiesRouteImport } from './routes/legal.cookies'
import { Route as LegalPrivacidadRouteImport } from './routes/legal.privacidad'
import { Route as PagoKoRouteImport } from './routes/pago.ko'
import { Route as PagoOkRouteImport } from './routes/pago.ok'
import { Route as SanSilvestreResultadoRouteImport } from './routes/san-silvestre.resultado'
import { Route as AuthenticatedGestionIndexRouteImport } from './routes/_authenticated/gestion.index'
import { Route as AuthenticatedGestionActividadRouteImport } from './routes/_authenticated/gestion.actividad'
import { Route as AuthenticatedGestionAdminsRouteImport } from './routes/_authenticated/gestion.admins'
import { Route as AuthenticatedGestionBloqueosRouteImport } from './routes/_authenticated/gestion.bloqueos'
import { Route as AuthenticatedGestionCalendarioRouteImport } from './routes/_authenticated/gestion.calendario'
import { Route as AuthenticatedGestionClientesRouteImport } from './routes/_authenticated/gestion.clientes'
import { Route as AuthenticatedGestionConfiguracionRouteImport } from './routes/_authenticated/gestion.configuracion'
import { Route as AuthenticatedGestionEnlacesPagoRouteImport } from './routes/_authenticated/gestion.enlaces-pago'
import { Route as AuthenticatedGestionFacturasRouteImport } from './routes/_authenticated/gestion.facturas'
import { Route as AuthenticatedGestionInformesRouteImport } from './routes/_authenticated/gestion.informes'
import { Route as AuthenticatedGestionIvaRouteImport } from './routes/_authenticated/gestion.iva'
import { Route as AuthenticatedGestionLimpiezaRouteImport } from './routes/_authenticated/gestion.limpieza'
import { Route as AuthenticatedGestionOperacionesRouteImport } from './routes/_authenticated/gestion.operaciones'
import { Route as AuthenticatedGestionPromocionesRouteImport } from './routes/_authenticated/gestion.promociones'
import { Route as AuthenticatedGestionReservasRouteImport } from './routes/_authenticated/gestion.reservas'
import { Route as AuthenticatedGestionSanSilvestreRouteImport } from './routes/_authenticated/gestion.san-silvestre'
import { Route as AuthenticatedGestionTarifasRouteImport } from './routes/_authenticated/gestion.tarifas'
import { Route as AuthenticatedGestionViajerosRouteImport } from './routes/_authenticated/gestion.viajeros'
import { Route as PagoEnlaceTokenRouteImport } from './routes/pago.enlace.$token'
import { Route as AuthenticatedGestionHabitacionesIndexRouteImport } from './routes/_authenticated/gestion.habitaciones.index'
import { Route as AuthenticatedGestionHabitacionesIdRouteImport } from './routes/_authenticated/gestion.habitaciones.$id'
import { Route as AuthenticatedGestionReservasIndexRouteImport } from './routes/_authenticated/gestion.reservas.index'
import { Route as AuthenticatedGestionReservasIdRouteImport } from './routes/_authenticated/gestion.reservas.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AlojamientoRoute = AlojamientoRouteImport.update({
            id: '/alojamiento',path: '/alojamiento',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CasaRuralCercaMadridRoute = CasaRuralCercaMadridRouteImport.update({
            id: '/casa-rural-cerca-madrid',path: '/casa-rural-cerca-madrid',getParentRoute: () => rootRouteImport
          })
const CasaRuralConChimeneaRoute = CasaRuralConChimeneaRouteImport.update({
            id: '/casa-rural-con-chimenea',path: '/casa-rural-con-chimenea',getParentRoute: () => rootRouteImport
          })
const CasaRuralEscapadaRomanticaRoute = CasaRuralEscapadaRomanticaRouteImport.update({
            id: '/casa-rural-escapada-romantica',path: '/casa-rural-escapada-romantica',getParentRoute: () => rootRouteImport
          })
const CasaRuralGuadalajaraRoute = CasaRuralGuadalajaraRouteImport.update({
            id: '/casa-rural-guadalajara',path: '/casa-rural-guadalajara',getParentRoute: () => rootRouteImport
          })
const CasaRuralGuadalajaraGruposRoute = CasaRuralGuadalajaraGruposRouteImport.update({
            id: '/casa-rural-guadalajara-grupos',path: '/casa-rural-guadalajara-grupos',getParentRoute: () => rootRouteImport
          })
const CasaRuralHayedoTejeraNegraRoute = CasaRuralHayedoTejeraNegraRouteImport.update({
            id: '/casa-rural-hayedo-tejera-negra',path: '/casa-rural-hayedo-tejera-negra',getParentRoute: () => rootRouteImport
          })
const CasaRuralPueblosNegrosRoute = CasaRuralPueblosNegrosRouteImport.update({
            id: '/casa-rural-pueblos-negros',path: '/casa-rural-pueblos-negros',getParentRoute: () => rootRouteImport
          })
const CasaRuralSierraNorteGuadalajaraRoute = CasaRuralSierraNorteGuadalajaraRouteImport.update({
            id: '/casa-rural-sierra-norte-guadalajara',path: '/casa-rural-sierra-norte-guadalajara',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const DorsalesRoute = DorsalesRouteImport.update({
            id: '/dorsales',path: '/dorsales',getParentRoute: () => rootRouteImport
          })
const EntornoRoute = EntornoRouteImport.update({
            id: '/entorno',path: '/entorno',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FinanciacionRoute = FinanciacionRouteImport.update({
            id: '/financiacion',path: '/financiacion',getParentRoute: () => rootRouteImport
          })
const GaleriaRoute = GaleriaRouteImport.update({
            id: '/galeria',path: '/galeria',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const ReservaRoute = ReservaRouteImport.update({
            id: '/reserva',path: '/reserva',getParentRoute: () => rootRouteImport
          })
const SanSilvestreSierraNorteRoute = SanSilvestreSierraNorteRouteImport.update({
            id: '/san-silvestre-sierra-norte',path: '/san-silvestre-sierra-norte',getParentRoute: () => rootRouteImport
          })
const TarifasRoute = TarifasRouteImport.update({
            id: '/tarifas',path: '/tarifas',getParentRoute: () => rootRouteImport
          })
const AuthenticatedGestionRoute = AuthenticatedGestionRouteImport.update({
            id: '/gestion',path: '/gestion',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CheckinTokenRoute = CheckinTokenRouteImport.update({
            id: '/checkin/$token',path: '/checkin/$token',getParentRoute: () => rootRouteImport
          })
const GestionEscanearRoute = GestionEscanearRouteImport.update({
            id: '/gestion_/escanear',path: '/gestion/escanear',getParentRoute: () => rootRouteImport
          })
const GestionValidarRoute = GestionValidarRouteImport.update({
            id: '/gestion_/validar',path: '/gestion/validar',getParentRoute: () => rootRouteImport
          })
const LegalAvisoLegalRoute = LegalAvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => LegalRoute
          })
const LegalCondicionesRoute = LegalCondicionesRouteImport.update({
            id: '/condiciones',path: '/condiciones',getParentRoute: () => LegalRoute
          })
const LegalCookiesRoute = LegalCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => LegalRoute
          })
const LegalPrivacidadRoute = LegalPrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => LegalRoute
          })
const PagoKoRoute = PagoKoRouteImport.update({
            id: '/pago/ko',path: '/pago/ko',getParentRoute: () => rootRouteImport
          })
const PagoOkRoute = PagoOkRouteImport.update({
            id: '/pago/ok',path: '/pago/ok',getParentRoute: () => rootRouteImport
          })
const SanSilvestreResultadoRoute = SanSilvestreResultadoRouteImport.update({
            id: '/san-silvestre/resultado',path: '/san-silvestre/resultado',getParentRoute: () => rootRouteImport
          })
const AuthenticatedGestionIndexRoute = AuthenticatedGestionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionActividadRoute = AuthenticatedGestionActividadRouteImport.update({
            id: '/actividad',path: '/actividad',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionAdminsRoute = AuthenticatedGestionAdminsRouteImport.update({
            id: '/admins',path: '/admins',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionBloqueosRoute = AuthenticatedGestionBloqueosRouteImport.update({
            id: '/bloqueos',path: '/bloqueos',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionCalendarioRoute = AuthenticatedGestionCalendarioRouteImport.update({
            id: '/calendario',path: '/calendario',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionClientesRoute = AuthenticatedGestionClientesRouteImport.update({
            id: '/clientes',path: '/clientes',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionConfiguracionRoute = AuthenticatedGestionConfiguracionRouteImport.update({
            id: '/configuracion',path: '/configuracion',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionEnlacesPagoRoute = AuthenticatedGestionEnlacesPagoRouteImport.update({
            id: '/enlaces-pago',path: '/enlaces-pago',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionFacturasRoute = AuthenticatedGestionFacturasRouteImport.update({
            id: '/facturas',path: '/facturas',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionInformesRoute = AuthenticatedGestionInformesRouteImport.update({
            id: '/informes',path: '/informes',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionIvaRoute = AuthenticatedGestionIvaRouteImport.update({
            id: '/iva',path: '/iva',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionLimpiezaRoute = AuthenticatedGestionLimpiezaRouteImport.update({
            id: '/limpieza',path: '/limpieza',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionOperacionesRoute = AuthenticatedGestionOperacionesRouteImport.update({
            id: '/operaciones',path: '/operaciones',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionPromocionesRoute = AuthenticatedGestionPromocionesRouteImport.update({
            id: '/promociones',path: '/promociones',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionReservasRoute = AuthenticatedGestionReservasRouteImport.update({
            id: '/reservas',path: '/reservas',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionSanSilvestreRoute = AuthenticatedGestionSanSilvestreRouteImport.update({
            id: '/san-silvestre',path: '/san-silvestre',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionTarifasRoute = AuthenticatedGestionTarifasRouteImport.update({
            id: '/tarifas',path: '/tarifas',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionViajerosRoute = AuthenticatedGestionViajerosRouteImport.update({
            id: '/viajeros',path: '/viajeros',getParentRoute: () => AuthenticatedGestionRoute
          })
const PagoEnlaceTokenRoute = PagoEnlaceTokenRouteImport.update({
            id: '/pago/enlace/$token',path: '/pago/enlace/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedGestionHabitacionesIndexRoute = AuthenticatedGestionHabitacionesIndexRouteImport.update({
            id: '/habitaciones/',path: '/habitaciones/',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionHabitacionesIdRoute = AuthenticatedGestionHabitacionesIdRouteImport.update({
            id: '/habitaciones/$id',path: '/habitaciones/$id',getParentRoute: () => AuthenticatedGestionRoute
          })
const AuthenticatedGestionReservasIndexRoute = AuthenticatedGestionReservasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedGestionReservasRoute
          })
const AuthenticatedGestionReservasIdRoute = AuthenticatedGestionReservasIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedGestionReservasRoute
          })





const AuthenticatedGestionReservasRouteChildren = {
  AuthenticatedGestionReservasIdRoute: AuthenticatedGestionReservasIdRoute,AuthenticatedGestionReservasIndexRoute: AuthenticatedGestionReservasIndexRoute
}

const AuthenticatedGestionReservasRouteWithChildren = AuthenticatedGestionReservasRoute._addFileChildren(AuthenticatedGestionReservasRouteChildren)



const AuthenticatedGestionRouteChildren = {
  AuthenticatedGestionActividadRoute: AuthenticatedGestionActividadRoute,AuthenticatedGestionAdminsRoute: AuthenticatedGestionAdminsRoute,AuthenticatedGestionBloqueosRoute: AuthenticatedGestionBloqueosRoute,AuthenticatedGestionCalendarioRoute: AuthenticatedGestionCalendarioRoute,AuthenticatedGestionClientesRoute: AuthenticatedGestionClientesRoute,AuthenticatedGestionConfiguracionRoute: AuthenticatedGestionConfiguracionRoute,AuthenticatedGestionEnlacesPagoRoute: AuthenticatedGestionEnlacesPagoRoute,AuthenticatedGestionFacturasRoute: AuthenticatedGestionFacturasRoute,AuthenticatedGestionInformesRoute: AuthenticatedGestionInformesRoute,AuthenticatedGestionIvaRoute: AuthenticatedGestionIvaRoute,AuthenticatedGestionLimpiezaRoute: AuthenticatedGestionLimpiezaRoute,AuthenticatedGestionOperacionesRoute: AuthenticatedGestionOperacionesRoute,AuthenticatedGestionPromocionesRoute: AuthenticatedGestionPromocionesRoute,AuthenticatedGestionReservasRoute: AuthenticatedGestionReservasRouteWithChildren,AuthenticatedGestionSanSilvestreRoute: AuthenticatedGestionSanSilvestreRoute,AuthenticatedGestionTarifasRoute: AuthenticatedGestionTarifasRoute,AuthenticatedGestionViajerosRoute: AuthenticatedGestionViajerosRoute,AuthenticatedGestionIndexRoute: AuthenticatedGestionIndexRoute,AuthenticatedGestionHabitacionesIdRoute: AuthenticatedGestionHabitacionesIdRoute,AuthenticatedGestionHabitacionesIndexRoute: AuthenticatedGestionHabitacionesIndexRoute
}

const AuthenticatedGestionRouteWithChildren = AuthenticatedGestionRoute._addFileChildren(AuthenticatedGestionRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedGestionRoute: AuthenticatedGestionRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const LegalRouteChildren = {
  LegalAvisoLegalRoute: LegalAvisoLegalRoute,LegalCondicionesRoute: LegalCondicionesRoute,LegalCookiesRoute: LegalCookiesRoute,LegalPrivacidadRoute: LegalPrivacidadRoute
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AlojamientoRoute: AlojamientoRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,CasaRuralCercaMadridRoute: CasaRuralCercaMadridRoute,CasaRuralConChimeneaRoute: CasaRuralConChimeneaRoute,CasaRuralEscapadaRomanticaRoute: CasaRuralEscapadaRomanticaRoute,CasaRuralGuadalajaraRoute: CasaRuralGuadalajaraRoute,CasaRuralGuadalajaraGruposRoute: CasaRuralGuadalajaraGruposRoute,CasaRuralHayedoTejeraNegraRoute: CasaRuralHayedoTejeraNegraRoute,CasaRuralPueblosNegrosRoute: CasaRuralPueblosNegrosRoute,CasaRuralSierraNorteGuadalajaraRoute: CasaRuralSierraNorteGuadalajaraRoute,ContactoRoute: ContactoRoute,DorsalesRoute: DorsalesRoute,EntornoRoute: EntornoRoute,FaqRoute: FaqRoute,FinanciacionRoute: FinanciacionRoute,GaleriaRoute: GaleriaRoute,LegalRoute: LegalRouteWithChildren,ReservaRoute: ReservaRoute,SanSilvestreSierraNorteRoute: SanSilvestreSierraNorteRoute,TarifasRoute: TarifasRoute,CheckinTokenRoute: CheckinTokenRoute,GestionEscanearRoute: GestionEscanearRoute,GestionValidarRoute: GestionValidarRoute,PagoKoRoute: PagoKoRoute,PagoOkRoute: PagoOkRoute,SanSilvestreResultadoRoute: SanSilvestreResultadoRoute,PagoEnlaceTokenRoute: PagoEnlaceTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)